<div class="login-panel" [attr.data-active-method]="activeLoginMethod">
  <div class="login-methods" role="tablist">
    <button type="button"
      class="login-method-tab"
      *ngFor="let method of loginMethods"
      role="tab"
      [attr.aria-selected]="isActiveMethod(method.id)"
      [class.active]="isActiveMethod(method.id)"
      [disabled]="isSigningIn"
      (click)="setLoginMethod(method.id)">
      <img class="login-method-icon" [src]="method.iconSrc" alt="" aria-hidden="true" />
      <span class="login-method-label" [translate]="method.labelKey"></span>
    </button>
  </div>

  <!-- Username / Password -->
  <form class="login-form" [formGroup]="signInForm" *ngIf="isActiveMethod('username')" role="tabpanel">
    <div class="login-field">
      <label for="username" translate>label_username</label>
      <div class="login-input-icon">
        <img class="input-prefix-icon" [src]="loginIconPaths.user" alt="" aria-hidden="true" />
        <input formControlName="username" id="username" type="text" pInputText
          class="has-prefix-icon" [placeholder]="usernamePlaceholder" [readonly]="isSigningIn"
          (keypress)="eventHandler($event)" />
      </div>
      <div class="form-errors"
        *ngIf="signInForm.controls.username.errors && (signInForm.controls.username.dirty || signInForm.controls.username.touched)">
        <div *ngIf="signInForm.controls.username.errors.required" translate>err_username_required</div>
        <div *ngIf="signInForm.controls.username.errors.maxlength" translate>exceed_max_length</div>
      </div>
    </div>

    <div class="login-field">
      <label for="password" translate>label_password_field</label>
      <div class="login-input-icon password-show">
        <img class="input-prefix-icon" [src]="loginIconPaths.lock" alt="" aria-hidden="true" />
        <input pInputText [type]="passwordType" id="password" formControlName="password"
          class="password-field has-prefix-icon has-suffix-icon"
          [placeholder]="passwordPlaceHolder" [readonly]="isSigningIn" (keypress)="eventHandler($event)" />
        <span class="eye-icon sign-in-eye" (click)="tooglePasswordType()">
          <img *ngIf="passwordType === 'password'" class="eye-toggle-icon"
            [src]="loginIconPaths.eyeOff" alt="" aria-hidden="true" />
          <i *ngIf="passwordType !== 'password'" class="fa fa-fw fa-eye" aria-hidden="true"></i>
        </span>
      </div>
      <div class="form-errors"
        *ngIf="signInForm.controls.password.errors && (signInForm.controls.password.dirty || signInForm.controls.password.touched)">
        <div *ngIf="signInForm.controls.password.errors.required" translate>error_password_required</div>
        <div *ngIf="signInForm.controls.password.errors.minlength" translate>password_too_short</div>
        <div *ngIf="signInForm.controls.password.errors.pattern" translate>error_password_validation</div>
      </div>
    </div>



    <button pButton appRipple [label]="signInLabel" class="sign-in-buttons" type="button"
      [disabled]="!signInForm.valid || isSigningIn" (click)="doSignIn()"></button>
  </form>

  <!-- Email OTP -->
  <form class="login-form" [formGroup]="emailOtpForm" *ngIf="isActiveMethod('emailOtp')" role="tabpanel">
    <div class="login-field">
      <label for="emailOtpEmail" translate>label_email_address</label>
      <div class="login-input-icon" [class.is-disabled]="emailOtpSent">
        <img class="input-prefix-icon" [src]="loginIconPaths.email" alt="" aria-hidden="true" />
        <input formControlName="email" id="emailOtpEmail" type="text" pInputText
          class="has-prefix-icon" [class.has-suffix-icon]="emailOtpSent"
          [placeholder]="emailPlaceholder" [readonly]="emailOtpSent"
          (keypress)="eventHandler($event)" />
        <button *ngIf="emailOtpSent" type="button" class="otp-identity-edit"
          [disabled]="isSigningIn"
          [attr.aria-label]="changeLabel"
          (click)="changeEmailOtpIdentity()">
          <img [src]="loginIconPaths.edit" alt="" aria-hidden="true" />
        </button>
      </div>
      <div class="form-errors"
        *ngIf="emailOtpForm.controls.email.errors && (emailOtpForm.controls.email.dirty || emailOtpForm.controls.email.touched)">
        <div *ngIf="emailOtpForm.controls.email.errors.required" translate>error_email_is_required</div>
        <div *ngIf="emailOtpForm.controls.email.errors.pattern" translate>error_invalid_email</div>
      </div>
    </div>

    <button *ngIf="!emailOtpSent" pButton appRipple [label]="sendOtpLabel" class="sign-in-buttons" type="button"
      [disabled]="emailOtpForm.controls.email.invalid || emailOtpSending || isSigningIn" (click)="sendEmailOtp()"></button>
    <p *ngIf="!emailOtpSent" class="otp-help-text" translate>label_otp_help_email</p>

    <ng-container *ngIf="emailOtpSent">
      <div class="login-field otp-entry-field">
        <div class="otp-digit-row" role="group" aria-label="One-time password">
          <input #emailOtpDigitInput class="otp-digit-input" id="emailOtpDigit0" type="text"
            inputmode="numeric" autocomplete="one-time-code" maxlength="1" [readonly]="isSigningIn"
            (input)="onOtpDigitInput('email', 0, $event)"
            (keydown)="onOtpDigitKeyDown('email', 0, $event)"
            (paste)="onOtpPaste('email', $event)" />
          <input #emailOtpDigitInput class="otp-digit-input" id="emailOtpDigit1" type="text"
            inputmode="numeric" maxlength="1" [readonly]="isSigningIn"
            (input)="onOtpDigitInput('email', 1, $event)"
            (keydown)="onOtpDigitKeyDown('email', 1, $event)"
            (paste)="onOtpPaste('email', $event)" />
          <input #emailOtpDigitInput class="otp-digit-input" id="emailOtpDigit2" type="text"
            inputmode="numeric" maxlength="1" [readonly]="isSigningIn"
            (input)="onOtpDigitInput('email', 2, $event)"
            (keydown)="onOtpDigitKeyDown('email', 2, $event)"
            (paste)="onOtpPaste('email', $event)" />
          <input #emailOtpDigitInput class="otp-digit-input" id="emailOtpDigit3" type="text"
            inputmode="numeric" maxlength="1" [readonly]="isSigningIn"
            (input)="onOtpDigitInput('email', 3, $event)"
            (keydown)="onOtpDigitKeyDown('email', 3, $event)"
            (paste)="onOtpPaste('email', $event)" />
        </div>
        <input type="hidden" formControlName="otp" tabindex="-1" aria-hidden="true" />
        <div class="form-errors"
          *ngIf="emailOtpForm.controls.otp.errors && (emailOtpForm.controls.otp.dirty || emailOtpForm.controls.otp.touched)">
          <div *ngIf="emailOtpForm.controls.otp.errors.required || emailOtpForm.controls.otp.errors.minlength || emailOtpForm.controls.otp.errors.pattern"
            translate>invalid_otp</div>
        </div>
      </div>

      <div class="otp-resend-row">
        <a *ngIf="emailOtpResendCooldown === 0 && !isSigningIn" class="forgot-link"
          href="javascript:void(0)" (click)="sendEmailOtp()">{{resendOtpLabel}}</a>
        <span *ngIf="emailOtpResendCooldown > 0" class="resend-otp-cooldown">
          {{resendOtpLabel}} <strong>{{emailOtpResendCooldown}} sec</strong>
        </span>
      </div>

      <button pButton appRipple [label]="submitLabel" class="sign-in-buttons" type="button"
        [disabled]="!emailOtpForm.valid || isSigningIn" (click)="doEmailOtpSignIn()"></button>
      <p class="otp-help-text" translate>label_otp_help_email</p>
    </ng-container>
  </form>

  <!-- Phone OTP -->
  <form class="login-form" [formGroup]="phoneOtpForm" *ngIf="isActiveMethod('phoneOtp')" role="tabpanel">
    <div class="login-field">
      <label for="phoneOtpPhone" translate>label_phone_number</label>
      <div class="phone-otp-row" [class.is-disabled]="phoneOtpSent">
        <div class="country-code-field">
          <p-dropdown
            inputId="phone-otp-country-code-dropdown"
            [options]="countryCodeList"
            formControlName="numCountryCode"
            optionLabel="label"
            optionValue="value"
            [filter]="true"
            filterBy="label"
            appendTo="body"
            [baseZIndex]="11000"
            [autoZIndex]="true"
            panelStyleClass="user-form-overlay-panel login-country-code-panel"
            styleClass="login-country-code-dropdown"
            [resetFilterOnHide]="true"
            [disabled]="phoneOtpSent">
            <ng-template pTemplate="selectedItem" let-selectedOption>
              <div class="flex align-items-center gap-2" *ngIf="selectedOption">
                <span class="country-flag" [ngStyle]="getCountryFlagStyle(selectedOption.value)"></span>
                <span>{{ selectedOption.label }}</span>
              </div>
            </ng-template>
            <ng-template pTemplate="item" let-country>
              <div class="flex align-items-center gap-2">
                <span class="country-flag" [ngStyle]="getCountryFlagStyle(country.value)"></span>
                <span>{{ country.label }}</span>
              </div>
            </ng-template>
            <ng-template pTemplate="filter" let-options="options">
              <div class="location-multislectect">
                <input #phoneOtpCountryCodeFilterInput type="text" pInputText [placeholder]="'label_search' | translate"
                  (input)="options.filter($event)" />
                <i *ngIf="phoneOtpCountryCodeFilterInput.value" class="pi pi-times passenger-type-filter-clear"
                  (click)="$event.preventDefault(); $event.stopPropagation(); phoneOtpCountryCodeFilterInput.value=''; options.reset()"></i>
                <i class="pi pi-search passenger-type-filter-search"></i>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <div class="login-input-icon phone-number-field" [class.is-disabled]="phoneOtpSent">
          <img class="input-prefix-icon" [src]="loginIconPaths.phone" alt="" aria-hidden="true" />
          <input formControlName="phone" id="phoneOtpPhone" type="tel" pInputText
            class="has-prefix-icon" [class.has-suffix-icon]="phoneOtpSent"
            inputmode="numeric" autocomplete="tel-national"
            [placeholder]="phonePlaceholder" [readonly]="phoneOtpSent"
            (keypress)="onPhoneKeyPress($event)" (input)="onPhoneInput()" />
          <button *ngIf="phoneOtpSent" type="button" class="otp-identity-edit"
            [disabled]="isSigningIn"
            [attr.aria-label]="changeLabel"
            (click)="changePhoneOtpIdentity()">
            <img [src]="loginIconPaths.edit" alt="" aria-hidden="true" />
          </button>
        </div>
      </div>
      <div class="form-errors"
        *ngIf="phoneOtpForm.controls.numCountryCode.errors && (phoneOtpForm.controls.numCountryCode.dirty || phoneOtpForm.controls.numCountryCode.touched)">
        <div *ngIf="phoneOtpForm.controls.numCountryCode.errors.required" translate>label_this_is_required</div>
      </div>
      <div class="form-errors"
        *ngIf="phoneOtpForm.controls.phone.errors && (phoneOtpForm.controls.phone.dirty || phoneOtpForm.controls.phone.touched)">
        <div *ngIf="phoneOtpForm.controls.phone.errors.required" translate>label_this_is_required</div>
        <div *ngIf="phoneOtpForm.controls.phone.errors.pattern" translate>error_invalid_phone_number_common</div>
      </div>
    </div>

    <button *ngIf="!phoneOtpSent" pButton appRipple [label]="sendOtpLabel" class="sign-in-buttons" type="button"
      [disabled]="phoneOtpForm.controls.numCountryCode.invalid || phoneOtpForm.controls.phone.invalid || phoneOtpSending || isSigningIn"
      (click)="sendPhoneOtp()"></button>
    <p *ngIf="!phoneOtpSent" class="otp-help-text" translate>label_otp_help_phone</p>

    <ng-container *ngIf="phoneOtpSent">
      <div class="login-field otp-entry-field">
        <div class="otp-digit-row" role="group" aria-label="One-time password">
          <input #phoneOtpDigitInput class="otp-digit-input" id="phoneOtpDigit0" type="text"
            inputmode="numeric" autocomplete="one-time-code" maxlength="1" [readonly]="isSigningIn"
            (input)="onOtpDigitInput('phone', 0, $event)"
            (keydown)="onOtpDigitKeyDown('phone', 0, $event)"
            (paste)="onOtpPaste('phone', $event)" />
          <input #phoneOtpDigitInput class="otp-digit-input" id="phoneOtpDigit1" type="text"
            inputmode="numeric" maxlength="1" [readonly]="isSigningIn"
            (input)="onOtpDigitInput('phone', 1, $event)"
            (keydown)="onOtpDigitKeyDown('phone', 1, $event)"
            (paste)="onOtpPaste('phone', $event)" />
          <input #phoneOtpDigitInput class="otp-digit-input" id="phoneOtpDigit2" type="text"
            inputmode="numeric" maxlength="1" [readonly]="isSigningIn"
            (input)="onOtpDigitInput('phone', 2, $event)"
            (keydown)="onOtpDigitKeyDown('phone', 2, $event)"
            (paste)="onOtpPaste('phone', $event)" />
          <input #phoneOtpDigitInput class="otp-digit-input" id="phoneOtpDigit3" type="text"
            inputmode="numeric" maxlength="1" [readonly]="isSigningIn"
            (input)="onOtpDigitInput('phone', 3, $event)"
            (keydown)="onOtpDigitKeyDown('phone', 3, $event)"
            (paste)="onOtpPaste('phone', $event)" />
        </div>
        <input type="hidden" formControlName="otp" tabindex="-1" aria-hidden="true" />
        <div class="form-errors"
          *ngIf="phoneOtpForm.controls.otp.errors && (phoneOtpForm.controls.otp.dirty || phoneOtpForm.controls.otp.touched)">
          <div *ngIf="phoneOtpForm.controls.otp.errors.required || phoneOtpForm.controls.otp.errors.minlength || phoneOtpForm.controls.otp.errors.pattern"
            translate>invalid_otp</div>
        </div>
      </div>

      <div class="otp-resend-row">
        <a *ngIf="phoneOtpResendCooldown === 0 && !isSigningIn" class="forgot-link"
          href="javascript:void(0)" (click)="sendPhoneOtp()">{{resendOtpLabel}}</a>
        <span *ngIf="phoneOtpResendCooldown > 0" class="resend-otp-cooldown">
          {{resendOtpLabel}} <strong>{{phoneOtpResendCooldown}} sec</strong>
        </span>
      </div>

      <button pButton appRipple [label]="submitLabel" class="sign-in-buttons" type="button"
        [disabled]="!phoneOtpForm.valid || isSigningIn" (click)="doPhoneOtpSignIn()"></button>
      <p class="otp-help-text" translate>label_otp_help_phone</p>
    </ng-container>
  </form>

  <!-- SSO -->
  <div class="login-form" *ngIf="isActiveMethod('sso')" role="tabpanel">
    <p class="sso-login-copy" translate>label_sso_login_help</p>
    <button pButton appRipple [label]="signInLabelWithSSO" class="sign-in-buttons" type="button"
      [disabled]="!userCommonService.ssoFeature || isSigningIn" (click)="doSignInWithSSO()"></button>
  </div>

  <div class="login-support-divider">
    <span translate>label_or</span>
  </div>

  <div class="login-support-box">
    <span translate>label_need_help_signing_in</span>
    <a routerLink="/support" class="contact-support-link">
      <img class="contact-support-icon" [src]="loginIconPaths.support" alt="" aria-hidden="true" />
      <span translate>label_contact_support</span>
    </a>
  </div>
</div>
